import { FC, useEffect } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch } from 'app/hooks/useStore';
// Actions
import { EpisodesActions } from 'app/store/Episodes/Episodes.slice';
// Mui
import { Box, Toolbar, Typography } from '@mui/material';
// Components
import EpisodeDetails from './EpisodeDetails';
import EpisodesFilters from './EpisodesFilters';
import EpisodesList from './EpisodesList';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const EpisodesPage:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(MixpanelActions.handleCaseEpisodesViewClick());
    
    return () => {
      dispatch(EpisodesActions.setInitialField('selectedEpisodeId'));
      dispatch(EpisodesActions.setInitialField('episodesFilters'));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Toolbar variant="dense">
        <Typography variant="h6">{t('pages.episodes.title')}</Typography>
      </Toolbar>

      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden' }}>
        <EpisodesFilters />
        
        <Box sx={{
          px: 4, pb: 4,
          display: 'flex',
          justifyContent: 'center',
          gap: 4,
          flexGrow: 1,
          overflow: 'hidden'
        }}>
          <EpisodesList />
          <EpisodeDetails />
        </Box>
      </Box>
    </Box>
  )
}

export default EpisodesPage;
